import React from "react";
import { Routes, Route, Link } from "react-router-dom";

import Scan from "./components/Scan";
import Note from "./components/Note";
import Error from "./components/Error";
import Complete from "./components/Complete";
import Landing from "./components/Landing";

function App() {
  return (
    <>
      <div className="nav-bar">
        <Link to="/">Start</Link>
        <Link to="/scan">Scan</Link>
        <Link to="/note">Note</Link>
        <Link to="/send">Send</Link>
      </div>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/scan" element={<Scan />} />
        <Route path="/note" element={<Note />} />
        <Route path="/send" element={<Complete />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </>
  );
}

export default App;

// import React, { useState } from "react";
// //import { QrScanner } from "@yudiel/react-qr-scanner";
// //import { BrowserMultiFormatReader } from '@zxing/library';
// import Modal from "./Modal";
// import { useZxing } from "react-zxing";
// import "./App.css";

// const App = () => {
//   const [data, setData] = useState([]);
//   const [readable, setReadable] = useState([]);
//   const [pause, setPause] = useState(true);
//   const [resultPoints, setResultPoints] = useState([]);
//   const [highlight, setHighlight] = useState(false);
//   const [boxHighlight, setBoxHighlight] = useState(false);
//   const [date, setDate] = useState("");
//   const [who, setWho] = useState("");
//   const [notes, setNotes] = useState();
//   const [modalShow, setModalShow] = useState(false);
//   const [modalItem, setModalItem] = useState(null);
//   const [tookSwatch, setTookSwatch] = useState({});

//   const getTheDate = (timeStamp) => {
//     const dateFormat = new Date(timeStamp);
//     return dateFormat.toDateString();
//   };

//   function getReadableName(data) {
//     const matName = data.split("|")[1];
//     const swatchDetails = data.split(">")[1];
//     return matName.toUpperCase().replaceAll("-", " ") + " > " + swatchDetails;
//   }

//   const { ref } = useZxing({
//     timeBetweenDecodingAttempts: 50,
//     paused: pause,
//     onResult(result) {
//       setHighlight(false);
//       setResultPoints(result.getResultPoints());
//       if (
//         result.getText().substring(0, 3) &&
//         !data.includes(result.getText())
//       ) {
//         setData([...data, result.getText()]);
//         setReadable([...readable, getReadableName(result.getText())]);
//         setDate(getTheDate(result.getTimestamp()));
//         setHighlight(true);
//         setBoxHighlight(true);
//       }
//       setTimeout(() => {
//         setResultPoints([]);
//         setHighlight(false);
//         setBoxHighlight(false);
//       }, 100);
//     },
//     onError(error) {
//       //console.log("why errors bitch", error);
//     },
//   });

//   const videoPause = (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       fill="none"
//       viewBox="0 0 24 24"
//       strokeWidth="1.5"
//       stroke="currentColor"
//       style={{ width: "70px", stroke: "#41d6e1" }}
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 00-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409"
//       />
//     </svg>
//   );

//   const trash = (
//     <svg
//       fill="none"
//       viewBox="0 0 24 24"
//       strokeWidth={1.5}
//       stroke="currentColor"
//       width="20px"
//       height="20px"
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
//       />
//     </svg>
//   );

//   const elipsisIcon = (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       fill="none"
//       viewBox="0 0 24 24"
//       strokeWidth="1.5"
//       stroke="currentColor"
//       width="20px"
//       height="20px"
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
//       />
//     </svg>
//   );

//   const tab = {
//     fill: "none",
//     stroke: highlight ? "#FF0000" : "#41d6e1",
//     strokeWidth: 5,
//     strokeLinecap: "round",
//     strokeMiterlimit: 10,
//   };

//   const focusSquare = {
//     fill: "none",
//     stroke: boxHighlight ? "#FF0000" : "#41d6e1",
//     strokeWidth: 2,
//     strokeLinecap: "round",
//     strokeMiterlimit: 10,
//     strokeDasharray: "6,6",
//   };

//   const handleWho = (e) => {
//     setWho(e.target.value);
//   };

//   const handleEmail = () => {
//     fetch("http://localhost:5001/mail/send", {
//       method: "POST",
//       body: JSON.stringify({
//         readable,
//         date,
//         who,
//         notes,
//       }),
//       headers: {
//         "Content-type": "application/json; charset=UTF-8",
//       },
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         console.log(data);
//         setPause(true);
//         setWho("");
//         setData([]);
//         setReadable([]);
//         //setNotes("");
//         // Handle data
//       })
//       .catch((err) => {
//         console.log(err.message);
//       });
//   };

//   const handleSelectedItem = (item) => {
//     setModalShow(true);
//     setModalItem(item);
//     console.log("you selected item ", item, " with a value of ", data[item]);
//   };
//   const handleTookSwatch = (item) => {
//     console.log(readable[item]);
//     //setTookSwatch(item)
//   };

//   const handleClearMaterialData = () => {
//     setData([]);
//     setReadable([]);
//   };

//   return (
//     <div className="main">
//       {modalShow ? (
//         <Modal
//           setModalShow={setModalShow}
//           modalItem={modalItem}
//           tookSwatch={tookSwatch}
//           readable={readable}
//           setTookSwatch={setTookSwatch}
//           handleTookSwatch={handleTookSwatch}
//         />
//       ) : null}
//       <div className="scanner">
//         <video
//           ref={ref}
//           width="400"
//           height="300"
//           onCanPlay={() => setPause(false)}
//         ></video>
//         {pause ? (
//           <div onClick={() => setPause(false)} className="pause-button">
//             {videoPause}
//           </div>
//         ) : (
//           <div className="pause-button" onClick={() => setPause(true)}></div>
//         )}
//         <svg
//           id="overBox"
//           x="0px"
//           y="0px"
//           viewBox="0 0 400 300"
//           style={{
//             position: "absolute",
//             top: 0,
//             width: "400px",
//             height: "300px",
//           }}
//         >
//           <path
//             id="shade"
//             fill="#00000050"
//             d="M0,0v300h400V0H0z M380.1,276c0,2.2-1.8,4-4,4H24c-2.2,0-4-1.8-4-4V24c0-2.2,1.8-4,4-4h352.1c2.2,0,4,1.8,4,4
// 	V276z"
//           />
//           <g id="frameTabs">
//             <path style={tab} d="M20,70l0-46c0-2.2,1.8-4,4-4l46,0" />
//             <path style={tab} d="M380,230v46c0,2.2-1.8,4-4,4h-46" />
//             <path style={tab} d="M20,230l0,46c0,2.2,1.8,4,4,4h46" />
//             <path style={tab} d="M380,70V24c0-2.2-1.8-4-4-4l-46,0" />
//           </g>
//           {resultPoints.length ? (
//             <g style={{ transform: "scale(1.2)" }}>
//               <polygon
//                 points={`
//             ${resultPoints[0].x / 1.6}, ${resultPoints[0].y / 1.6}
//             ${resultPoints[1].x / 1.6}, ${resultPoints[1].y / 1.6}
//             ${resultPoints[2].x / 1.6}, ${resultPoints[2].y / 1.6}
//             ${
//               resultPoints[3]
//                 ? (resultPoints[3].x + 10) / 1.6
//                 : (resultPoints[2].x + 10) / 1.6
//             }, ${
//                   resultPoints[3]
//                     ? (resultPoints[3].y + 10) / 1.6
//                     : (resultPoints[2].y + 10) / 1.6
//                 }

//             `}
//                 style={focusSquare}
//               />
//             </g>
//           ) : null}
//         </svg>
//       </div>
//       <div className="mid-text-area">
//         {data.length !== 0 ? (
//           <>
//             <h4>
//               {data.length} {data.length >= 2 ? "items" : "item"} scanned
//             </h4>
//             {data.length ? (
//               <div className="clearList" onClick={handleClearMaterialData}>
//                 <span>{trash}</span>
//               </div>
//             ) : null}
//           </>
//         ) : (
//           <h4>No items scanned</h4>
//         )}
//       </div>
//       <div className="output">
//         <ul className="article-list">
//           {readable
//             ? readable.map((item, i) => (
//                 <li key={item}>
//                   {item}{" "}
//                   <div className="selectedItem">
//                     <span onClick={() => handleSelectedItem(i)}>
//                       {elipsisIcon}
//                     </span>
//                   </div>
//                 </li>
//               ))
//             : "no results"}
//         </ul>
//       </div>
//       <div className="bottom-button-row">
//         <div className="date">{date}</div>
//         <input
//           className="whoInput"
//           type="text"
//           value={who}
//           onChange={handleWho}
//           placeholder="what's happening"
//         />
//         <div className="emailButton" onClick={data.length ? handleEmail : null}>
//           {data.length ? "Send it!" : "Scan first..."}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default App;

// import React, { useEffect, useRef } from "react";
// import "./App.css";

// const App = () => {
//   const videoRef = useRef(null);
//   const photoRef = useRef(null);
//   const stripRef = useRef(null);
//   const colorRef = useRef(null);

//   useEffect(() => {
//     getVideo();
//   }, [videoRef]);

//   const getVideo = () => {
//     navigator.mediaDevices
//       .getUserMedia({ video: { width: 300 } })
//       .then((stream) => {
//         let video = videoRef.current;
//         video.srcObject = stream;
//         video.play();
//       })
//       .catch((err) => {
//         console.error("error:", err);
//       });
//   };

//   const paintToCanvas = () => {
//     let video = videoRef.current;
//     let photo = photoRef.current;
//     let ctx = photo.getContext("2d", { willReadFrequently: true });

//     const width = 400;
//     const height = 300;
//     photo.width = width;
//     photo.height = height;

//     return setInterval(() => {
//       let color = colorRef.current;

//       ctx.drawImage(video, 0, 0, width, height);
//       let pixels = ctx.getImageData(0, 0, width, height);

//       color.style.backgroundColor = `rgb(${pixels.data[0]},${pixels.data[1]},${pixels.data[2]})`;
//       color.style.borderColor = `rgb(${pixels.data[0]},${pixels.data[1]},${pixels.data[2]})`;
//     }, 200);
//   };

//   const takePhoto = () => {
//     let photo = photoRef.current;
//     let strip = stripRef.current;

//     const data = photo.toDataURL("image/jpeg");

//     console.warn(data);
//     const link = document.createElement("a");
//     link.href = data;
//     link.setAttribute("download", "myWebcam");
//     link.innerHTML = `<img src='${data}' alt='thumbnail'/>`;
//     strip.insertBefore(link, strip.firstChild);
//   };

//   return (
//     <div className="container">
//       <div ref={colorRef} className="scene"></div>
//       <div className="webcam-video">
//         <button onClick={() => takePhoto()}>Take a photo</button>
//         <video
//           onCanPlay={() => paintToCanvas()}
//           ref={videoRef}
//           className="player"
//           style={{ display: "none" }}
//         />
//         <canvas ref={photoRef} className="photo" />
//         <div className="photo-booth">
//           <div ref={stripRef} className="strip" />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default App;

// import React, { useRef, useEffect } from "react";
// import { BrowserMultiFormatReader, BarcodeFormat } from "@zxing/browser";
// import DecodeHintType from "@zxing/library/cjs/core/DecodeHintType";
// //import {makeStyles} from "@material-ui/core/styles";

// // const useStyles = makeStyles(theme => ({
// //     video: {
// //         width: '100%',
// //         height: '100%',
// //         maxHeight: '50vh',
// //         objectFit: 'cover',
// //     },
// // }));

// export default function App({ callback }) {
//   const videoRef = useRef(null);
//   const canvasRef = useRef(null);
//   //const classes = useStyles();
//   //const video = useRef();
//   useEffect(() => {
//     const hints = new Map();
//     const formats = [
//       BarcodeFormat.QR_CODE,
//       BarcodeFormat.CODE_128,
//       BarcodeFormat.ITF,
//     ];
//     hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
//     const codeReader = new BrowserMultiFormatReader(hints, {
//       delayBetweenScanSuccess: 2000,
//       delayBetweenScanAttempts: 600,
//     });
//     var controls = null;
//     controls = codeReader.decodeFromVideoDevice(
//       undefined,
//       videoRef.current,
//       function(result, error) {
//         console.log(result);
//         // if (typeof result !== "undefined") {
//         //   callback(result); // redirect on different page and not render this
//         // }
//         //if (error) console.log(error);
//       }
//     );
//     useEffect(() => {
//       getVideo();
//     }, [videoRef]);

//     const getVideo = () => {
//       navigator.mediaDevices
//         .getUserMedia({ video: { width: 300 } })
//         .then((stream) => {
//           let video = videoRef.current;
//           video.srcObject = stream;
//           video.play();
//         })
//         .catch((err) => {
//           console.error("error:", err);
//         });
//     };
//     console.log(controls);

//     return function cleanup() {
//       console.log("clean");
//       //controls.stop();
//     };
//   });

//   const paintToCanvas = () => {
//     let video = videoRef.current;
//     //let photo = photoRef.current;
//     let ctx = video.getContext("2d", { willReadFrequently: true });

//     const width = 400;
//     const height = 300;
//     //photo.width = width;
//     //photo.height = height;

//     return setInterval(() => {
//       //let color = colorRef.current;

//       ctx.drawImage(videoRef, 0, 0, width, height);
//       //let pixels = ctx.getImageData(0, 0, width, height);

//       //color.style.backgroundColor = `rgb(${pixels.data[0]},${pixels.data[1]},${pixels.data[2]})`;
//       //color.style.borderColor = `rgb(${pixels.data[0]},${pixels.data[1]},${pixels.data[2]})`;
//     }, 200);
//   };

//   return (
//     <>
//       <video
//         onCanPlay={() => paintToCanvas()}
//         width={"400px"}
//         height="300px"
//         ref={videoRef}
//       ></video>
//       <canvas
//         id="canvas"
//         ref={canvasRef}
//         width={"400px"}
//         height="300px"
//       ></canvas>
//     </>
//   );
// }
